import { Banner, ClViewer, Logout } from 'components/shard'
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { Color, Size } from 'const'
import { MEDIA_QUERY } from 'config/constants'
import purchasesAPI from 'utils/axios/modules/purchases'
import { getDispDate } from 'utils/datetime'
import { Lens, Contact, Sunglasses, Frame } from 'components/shard/ProductInfo'
import { isBeforeOrEqualMock } from 'utils/helpers/function'
import _ from 'lodash'

const PurchaseDetail = () => {
  const [item, setItem] = useState({
    info: {
      shop_name: '―',
      salse_date: '',
      delivery_date: '',
      is_ninal_contract: '',
    },
    items: {
      sungalsses: {
        brand: '―',
        design: '',
        color: '',
        function: null,
        material: '',
        name: '',
        part_no: '',
        price: null,
        purchase_detail_id: '',
      },
      lens_r: {
        name_r: '―',
        price_r: 0,
        material_r: null,
        design_r: null,
        function_r: null,
        sph_r: '0',
        cyl_r: '0',
        add_r: '0',
        axis_r: null,
        pd_r: null,
      },
      lens_l: {
        name_l: '―',
        price_l: 0,
        material_l: null,
        design_l: null,
        function_l: null,
        sph_l: '0',
        cyl_l: '0',
        add_l: '0',
        axis_l: null,
        pd_l: null,
      },
      contact_lens_r: {
        purchase_detail_id: '',
        brand: '―',
        price: 0,
        part_no: '',
        name: '',
        focus: '',
        type: '',
        material: '',
        size: '',
        base_curve: '',
        lens_color: null,
        sph: null,
        cyl: null,
        add: null,
        ax: null,
        pd: null,
        quantity: 0,
        warranty: null,
      },
      contact_lens_l: {
        purchase_detail_id: '',
        brand: '―',
        price: 0,
        part_no: '',
        name: '',
        focus: '',
        type: '',
        material: '',
        size: '',
        base_curve: '',
        lens_color: null,
        sph: null,
        cyl: null,
        add: null,
        ax: null,
        pd: null,
        quantity: 0,
        warranty: null,
      },
    },
  })

  useEffect(() => {
    void (async () => {
      try {
        /* 履歴の詳細の取得 */
        const params = new URLSearchParams(window.location.search)
        const response = await purchasesAPI.getDetails({ salesId: params.get('sales_id') })
        if (!response.data) throw new Error('データがありません')
        setItem(response.data)
      } catch (error) {
        console.error(error)
      }
    })()
  }, [])

  const isBeforeOrEqual31thMarch2025 = isBeforeOrEqualMock(item.info.salse_date, '2025-03-31')

  const isContactLens =
    item.items.contact_lens_l?.brand ||
    item.items.contact_lens_l?.name ||
    item.items.contact_lens_r?.brand ||
    item.items.contact_lens_r?.name

  const defaultLens = {
    brand: '―',
    name: '',
    type: '',
  }

  return (
    <React.Fragment>
      {!item.info?.salse_date ? (
        <LoadingContainer>Loading...</LoadingContainer>
      ) : (
        <StyledPurchaseDetail>
          <div className="section-label">
            <h2 className="top">購入履歴</h2>
          </div>
          <div className="history_detail_wrapper">
            <div className="row">
              <div className="label">購入店舗</div>
              <div className="content">{item.info.shop_name}</div>
            </div>
            <div className="row">
              <div className="label">購入日</div>
              <div className="content">{item.info.salse_date ? getDispDate(item.info.salse_date) : '―'}</div>
            </div>
            <div className="row">
              <div className="label">受取日</div>
              <div className="content">{item.info.delivery_date ? getDispDate(item.info.delivery_date) : '―'}</div>
            </div>
          </div>
          <div className="section-label">
            <h2>購入商品</h2>
          </div>
          <div className="item_detail_wrapper">
            <Frame content={item.items.frame} />
            <Sunglasses content={item.items.sungalsses} />
            <Lens
              content_l={_.get(item.items, 'lens_l', defaultLens)}
              content_r={_.get(item.items, 'lens_r', defaultLens)}
            />
            <Contact
              content_l={_.get(item.items, 'contact_lens_l', defaultLens)}
              content_r={_.get(item.items, 'contact_lens_r', defaultLens)}
            />
          </div>
          <Separator />
          <ClViewer
            isContactLens={isContactLens}
            isBeforeOrEqual31thMarch2025={isBeforeOrEqual31thMarch2025}
            custom={false}
          />
        </StyledPurchaseDetail>
      )}
      <Banner />
      <Logout />
    </React.Fragment>
  )
}

const LoadingContainer = styled.div`
  margin: 20px 0 60px;
  padding: 0 24px;
`

const StyledPurchaseDetail = styled.div`
  padding: 0 24px;
  margin: 20px 0 60px;

  ${MEDIA_QUERY.SP} {
    padding: 0 20px;
    border-radius: 0;
    border: none;
  }
  > .section-label {
    display: flex;
    align-items: center;
    margin: 0 -20px;
    padding: 12px 20px;
    background-color: ${Color.GREY};
    > h2 {
      font-weight: 700;
      font-size: ${Size.FONT.BIGGER};

      &.top {
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
      }
    }
  }

  > .history_detail_wrapper {
    margin: 30px 0;
    ${MEDIA_QUERY.SP} {
      margin: 0;
    }
    > .row {
      display: flex;
      margin-bottom: 15px;
      ${MEDIA_QUERY.SP} {
        display: block;
        margin-bottom: 0;
        padding: 16px 0;
        + .row {
          border-top: solid 1px #f4f4f4;
        }
      }
      > .label {
        width: 160px;
        margin-right: 24px;
        ${MEDIA_QUERY.SP} {
          text-align: left;
          margin-bottom: 8px;
        }
        font-weight: 700;
        font-size: ${Size.FONT.BIG};
      }
      > .content {
        ${MEDIA_QUERY.SP} {
          white-space: pre-wrap;
        }
        font-size: ${Size.FONT.BIGGER};
        font-weight: 500;
      }
    }
  }
  > .item_detail_wrapper {
    margin-bottom: 30px;
    ${MEDIA_QUERY.SP} {
      margin-bottom: 40px;
    }
  }

  > .button_and_download_wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 40px 0 30px;
    > a {
      line-height: 24px;
      margin-top: 20px;
    }
  }

  > .download_caution {
    text-align: center;
    margin: 20px 0;
  }
`
const Separator = styled.div`
  height: 1px;
  background-color: ${Color.GREY};
`

export default PurchaseDetail
